// Exemplos de código da tela API de mensagens, montados com o que o usuário
// preencheu no formulário de teste.

const q = (value) => JSON.stringify(value ?? "");

export const buildSample = ({ lang, endpoint, token, type, number, body, name, closeTicket, fileName }) => {
  const n = number || "5511987654321";
  const t = token || "SEU_TOKEN";
  const file = fileName || "arquivo.pdf";

  if (lang === "js") {
    if (type === "text") {
      const fields = [`    number: ${q(n)}`, `    body: ${q(body)}`];
      if (name) fields.push(`    name: ${q(name)}`);
      if (closeTicket) fields.push("    closeTicket: true");
      return `await fetch(${q(endpoint)}, {
  method: "POST",
  headers: {
    "Authorization": "Bearer ${t}",
    "Content-Type": "application/json"
  },
  body: JSON.stringify({
${fields.join(",\n")}
  })
});`;
    }
    const lines = [`form.append("number", ${q(n)});`];
    if (body) lines.push(`form.append("body", ${q(body)});`);
    if (name) lines.push(`form.append("name", ${q(name)});`);
    if (closeTicket) lines.push(`form.append("closeTicket", "true");`);
    lines.push(`form.append("medias", arquivo); // File ou Blob`);
    return `const form = new FormData();
${lines.join("\n")}

await fetch(${q(endpoint)}, {
  method: "POST",
  headers: { "Authorization": "Bearer ${t}" },
  body: form
});`;
  }

  if (lang === "n8n") {
    const params = [`    number = ${n}`];
    if (body) params.push(`    body   = ${body}`);
    if (name) params.push(`    name   = ${name}`);
    if (closeTicket) params.push("    closeTicket = true");
    if (type === "media") params.push("    medias = (arquivo binário do nó anterior)");
    return `Nó: HTTP Request
  Method: POST
  URL:    ${endpoint}
  Authentication: Generic › Header Auth
    Name:  Authorization
    Value: Bearer ${t}
  Body Content Type: ${type === "text" ? "JSON" : "Form-Data"}
${params.join("\n")}`;
  }

  // cURL
  if (type === "text") {
    const payload = { number: n, body: body || "" };
    if (name) payload.name = name;
    if (closeTicket) payload.closeTicket = true;
    const json = JSON.stringify(payload).replace(/'/g, "'\\''");
    return `curl -X POST "${endpoint}" \\
  -H "Authorization: Bearer ${t}" \\
  -H "Content-Type: application/json" \\
  -d '${json}'`;
  }
  const esc = (v) => String(v).replace(/(["\\$`])/g, "\\$1");
  const parts = [`  -F "number=${esc(n)}"`];
  if (body) parts.push(`  -F "body=${esc(body)}"`);
  if (name) parts.push(`  -F "name=${esc(name)}"`);
  if (closeTicket) parts.push(`  -F "closeTicket=true"`);
  parts.push(`  -F "medias=@${esc(file)}"`);
  return `curl -X POST "${endpoint}" \\
  -H "Authorization: Bearer ${t}" \\
${parts.join(" \\\n")}`;
};

// Aceita espaços, traços, parênteses e "+". Devolve só os dígitos e se o
// formato parece válido (55 + DDD + número, 12 ou 13 dígitos).
export const parseNumber = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  const valid = digits.startsWith("55") && digits.length >= 12 && digits.length <= 13;
  return { digits, valid };
};

export const VARIABLES = [
  { key: "{{firstName}}", label: "Primeiro nome" },
  { key: "{{name}}", label: "Nome completo" },
  { key: "{{gretting}}", label: "Bom dia / Boa tarde / Boa noite" },
  { key: "{{hora}}", label: "Hora atual" },
];
